module.exports = __webpack_public_path__ + "img/9.1ff6d641.jpg";